import {
    Injectable,
    signal,
    WritableSignal
} from '@angular/core';

const AD_HOC_CODE_STORAGE_KEY = 'shop::adhocCode';

@Injectable({
    providedIn: 'root'
})
export class BillingDataService {
    private readonly _adHocCode: WritableSignal<string | null> = signal(this.readStoredAdHocCode());

    public adHocCode = this._adHocCode.asReadonly();

    /**
     * Sets the ad hoc code and stores it.
     * `undefined` means the code is unknown (e.g. the billing_data call failed): the stored one is kept.
     * `null` or an empty value means the shop has no code: the stored one is removed.
     */
    public setAdHocCode(adHocCode: string | null | undefined) {
        if (adHocCode === undefined) {
            return;
        }

        this._adHocCode.set(adHocCode || null);

        try {
            if (adHocCode) {
                localStorage.setItem(AD_HOC_CODE_STORAGE_KEY, adHocCode);
            } else {
                localStorage.removeItem(AD_HOC_CODE_STORAGE_KEY);
            }
        } catch {
            // localStorage not available: keep the in-memory value only
        }
    }

    private readStoredAdHocCode(): string | null {
        try {
            return localStorage.getItem(AD_HOC_CODE_STORAGE_KEY);
        } catch {
            return null;
        }
    }
}
